import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { HotelFilterProvider } from '@shared/hotel-itinerary/hotel-filters';
import { AppFacade } from '@app/app.facade';
import { SOURCE_PARAM } from '@app/modules/core/constants/query-params';
import { isTagTypeisPrime, isTagTypeisRappicard } from '@app/mappers/filters.mapper';
import { SharedSelectedFilterHotelValue } from '@shared/magic-filter-bar/entities/shared-props';
import { CheckboxFilter } from '@shared/filters/entities/fetch-filters.response';

@Component({
  selector: 'app-hotel-filter-bar-base',
  template: '',
  standalone: false
})
export class HotelFilterBarBaseContainer {

  @Input() viewType: HotelFilterProvider;
  @Input() isSticky: boolean;

  @Output() filtersHaveBeenApplicatedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  public pickedTotalDiscountPercentage = 0;
  public pickedMemberRatesOnly = false;
  public selectedStarItems = [];
  public pickedCheckboxes = [];
  public pickedStars = [];

  constructor(
    protected route: ActivatedRoute,
    protected appFacade: AppFacade,
    protected cdr: ChangeDetectorRef,
  ) { }

  get tagTypeIsPrime$(): Observable<boolean> {
    return this.isPrime$.pipe(map(isPrime => isTagTypeisPrime(this.searchSource, isPrime)));
  }

  get tagTypeIsRappicard$(): Observable<boolean> {
    return this.hasRappiCard$.pipe(map(hasRappiCard => isTagTypeisRappicard(this.searchSource, hasRappiCard)));
  }

  get isPrime$(): Observable<boolean> {
    return this.appFacade.isPrime$;
  }

  get hasRappiCard$(): Observable<boolean> {
    return this.appFacade.hasRappiCard$;
  }

  get showExclusiveOfferFilter$(): Observable<boolean> {
    return combineLatest([this.isPrime$, this.hasRappiCard$])
      .pipe(map(([isPrime, hasRappiCard]) => {
        return (isPrime || hasRappiCard);
      }));
  }

  get searchSource(): string {
    return this.route?.snapshot?.queryParams?.[SOURCE_PARAM];
  }

  protected sharedShouldShowFilters(value: boolean): void {
    this.filtersHaveBeenApplicatedEvent.emit(value);
  }

  public sharedSelectedHotelFilters(filters: { [key: string]: SharedSelectedFilterHotelValue }): void {
    this.selectedStarItems = filters.selectedStarItems as CheckboxFilter[];
    this.pickedCheckboxes = filters.pickedCheckboxes as string[];
    this.pickedStars = filters.pickedStars as string[];
    this.pickedTotalDiscountPercentage = filters.pickedTotalDiscountPercentage as number;
    this.pickedMemberRatesOnly = filters.pickedMemberRatesOnly as boolean;
    this.cdr.detectChanges();
  }

}
